import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsLogin, setIsSignUp, setUserLoginModal } from '../../actions/user-actions-types';
import { getRealBalanceObj, isSmartPhone } from '../../utilities/helper';
import useTheme from '../../utilities/hooks/theme';
import HeaderMWeb from './index_mWeb';
import HeaderWeb from './index_web';

const Header = ({ isWelcomeMessage }: any) => {
  const { DashboardTheme: theme } = useTheme();
  const {
    teamName = '',
    avatarId = 0,
    xpPoints = 0,
    balanceInfo = 0
  } = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const balance = getRealBalanceObj(balanceInfo);
  const signUpBtnStyle = {
    backgroundColor: theme.dashBoardHeaderSignUpBtn,
    border: 'none'
  };
  const logInBtnStyle = {
    border: `2px solid ${theme.dashBoardLoginBtnLabel}`,
    backgroundColor: theme.dashBoardLoginBtn,
    color: theme.dashBoardLoginBtnLabel
  };

  const xpCoinContainerStyle = {
    background: theme.dashBoardHeaderXpCoinContainerBg
  };
  const openLogInModal = () => {
    dispatch(setUserLoginModal(true));
    dispatch(setIsLogin(true));
  };
  const openSignUpModal = () => {
    dispatch(setUserLoginModal(true));
    dispatch(setIsSignUp(true));
  };
  return (
    <React.Fragment>
      {isSmartPhone ? (
        <HeaderMWeb
          logInBtnStyle={logInBtnStyle}
          signUpBtnStyle={signUpBtnStyle}
          xpCoinContainerStyle={xpCoinContainerStyle}
          avatarId={avatarId}
          teamName={teamName}
          balance={balance}
          isWelcomeMessage={isWelcomeMessage}
          xpPoints={xpPoints}
          openLogInModal={openLogInModal}
          openSignUpModal={openSignUpModal}
        />
      ) : (
        <HeaderWeb
          logInBtnStyle={logInBtnStyle}
          signUpBtnStyle={signUpBtnStyle}
          xpCoinContainerStyle={xpCoinContainerStyle}
          avatarId={avatarId}
          teamName={teamName}
          balance={balance}
          isWelcomeMessage={isWelcomeMessage}
          xpPoints={xpPoints}
          openLogInModal={openLogInModal}
          openSignUpModal={openSignUpModal}
        />
      )}
    </React.Fragment>
  );
};

export default Header;
